import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

//TAsk Filtering is yet to be Added
//@components
import ShotVersionsTools from "../ShotVersionsTools/ShotVersionsTools.component.jsx";

//@MUI
import { Box, Modal, Slide, Snackbar } from "@material-ui/core";

import { Alert } from "@material-ui/lab";
import {
  fget,
  fpatch,
  fpost,
  fpostBFF,
  uploadFile,
} from "../../../API/callsAPI";
import { MovieColabContext } from "../../../Context/MovieColabContext";
import NoData from "../../../Pages/InformativeComponents/NoData.component";
import { selectAppliedFilterForTrackable } from "../../../redux/selectors/projectFilters";
import CanvasFrame from "../../CanvasFrame/CanvasFrame.component";
import AssetAndShotVersionTimeline from "../../Utilities/AssetAndShotVersionTimeline/AssetAndShotVersionTimeline.jsx";
import CSVImportModal from "../../Utilities/CSVImportModal/CSVImportModal";
import CustomPagination from "../../Utilities/CustomPagination/CustomPagination.component";
import { mapFieldsFromConfig } from "../../Utilities/CustomTableForAllTrackables/fieldMapper.js";
import ExportModal from "../../Utilities/ExportModal/ExportModal";
import Loader from "../../Utilities/Loader/Loader";
import NewDataLoadingLoader from "../../Utilities/NewDataLoadingLoader/NewDataLoadingLoader.component";
import { StatusRearrange } from "../../Utilities/StatusRearrange/StatusRearrange";
import UpdateParentAssetOrShootThumbnailModal from "../../Utilities/UpdateParentAssetOrShootThumbnail/UpdateParentAssetOrShootThumbnailModal";
import VersionFilterModal from "../../Utilities/VersionFilterModal/VersionFilterModal";
import VersionViewerOverview from "../../Utilities/VersionViewer/VersionViewerOverview/VersionViewerOverview";
import ShotVersionCustomTable from "../ShotVersionTables/ShotVersionCustomTable.jsx";
import ShotVersionDefaultTable from "../ShotVersionTables/ShotVersionDefaultTable.jsx";
import ShotVersionNewVersionModal from "./../ShotVersionPageModals/ShotVersionNewVersionModal";
import useStyles from "./ShotversionsOverview.styles";

function ShotVersionsOverview(props) {
  const classes = useStyles();
  const history = useHistory();
  const tableRef = useRef();
  const { trackableClass: contextTrackableClass } =
    useContext(MovieColabContext);
  const shotVersionTrackableId = contextTrackableClass?.find(
    (trackable) => trackable.model?.toLowerCase() === "shotversion",
  )?.id;
  const appliedFilter = useSelector((state) =>
    selectAppliedFilterForTrackable(state, shotVersionTrackableId),
  );
  const appliedFilterIds = appliedFilter?.id != null ? [appliedFilter.id] : [];
  const appliedFilterKey = appliedFilter
    ? `${appliedFilter.id}:${JSON.stringify(appliedFilter.filters ?? [])}`
    : "";

  const [shotVersionList, setShotVersionList] = useState();
  const [parentShot, setParentShot] = useState();
  const [shotVersionFilteredStatus, setShotVersionFilteredStatus] =
    useState("");
  const [versionFromURL, setVersionFromURL] = useState(); //open versionDetailModal if id present in url

  const [trackableClass, setTrackableClass] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [allUsersName, setAllUsersName] = useState();
  const [isNewShotVersionModalOpen, setNewShotVersionModalOpen] =
    useState(false);
  const [sortByDefault, setSortByDefault] = useState("");
  const [isShotDetailModalOpen, setShotDetailModalOpen] = useState(false);
  const [selectedShotVersion, setSelectedShotVersion] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [shotVersionToggle, setShotVersionToggle] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [commentsRefreshCounter, setCommentsRefreshCounter] = useState(0);
  const [isUpdateParentShotModalOpen, setUpdateParentShotModalOpen] =
    useState(false);
  const [updatedFileForParent, setUpdatedFileForParent] = useState();
  const [dragScreen, setDragScreen] = useState(false);
  //state will be true when we start drag file inside modals
  const [dragFileEnterModal, setDragFileEnterModal] = useState(false);
  // to store tasks of the current trackable
  const [taskList, setTaskList] = useState([]);
  const [snackValue, setSnackValue] = React.useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  const [taskNameFromComment, setTaskNameFromComment] = useState("");
  const [canvasModal, setCanvasModal] = useState(false);
  const [imageRef, setImageRef] = useState(null);
  const [screenshot, setScreenshot] = useState(null);
  const [playerProgress, setPlayerProgress] = useState("00:00");
  const [scrollValue, setScrollValue] = useState("");
  const [updateOnPageChange, setUpdateOnPageChange] = useState(0);
  //statuslist of status linked with task
  const [taskStatusList, setTaskStatusList] = useState([]);
  const [isNewPageLoading, setIsNewPageLoading] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterValues, setFilterValues] = useState({
    status: "",
    task: "",
  });
  const [filterButtonActive, setFilterButtonActive] = useState(false);
  const [commentsPageNo, setCommentsPageNo] = useState(1);
  const [shotVersionStats, setShotVersionStats] = useState({
    total: 0,
    visibleCount: 0,
  });
  const [isTimeLineModalOpen, setIsTimeLineModalOpen] = useState(false);
  const [commentFilter, setCommentFilter] = useState("-created_at");
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [openBulkImportModal, setOpenBulkImportModal] = useState(false);
  const [allFieldsConfig, setAllFieldsConfig] = useState([]);
  const [isToggleView, setIsToggleView] = useState(false);

  function handleFilterModalState() {
    setIsFilterModalOpen(!isFilterModalOpen);
  }
  const [commentId, setCommentId] = useState(""); //to highlight comment if commentid present in url

  const decodedURL = decodeURIComponent(
    escape(window.atob(history.location.search.substring(1))),
  );
  var searchParams = new URLSearchParams(decodedURL);

  useEffect(() => {
    fetchTrackableClass();
    setShotVersionFilteredStatus(searchParams.get("status") || "");
    setVersionFromURL(searchParams.get("versionId") || "");
    setSortByDefault(searchParams.get("sortBy") || "A-Z");
    setCommentId(searchParams.get("commentId" || ""));

    var scrollStored = JSON.parse(localStorage.getItem("scroll"));
    if (scrollStored) {
      setScrollValue(scrollStored.shotVersion);
    } else {
      const scrollData = {
        asset: "0",
        assetVersion: "0",
        sequence: "0",
        shots: "0",
        shotVersion: "0",
      };
      localStorage.setItem("scroll", JSON.stringify(scrollData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchShotVersion();
  }, []);

  const updateRefreshCounter = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  const handlePageChange = (pageNo) => {
    setCurrentPage(pageNo);
    setUpdateOnPageChange(updateOnPageChange + 1);
  };

  const updateCommentsRefreshCounter = () => {
    setCommentsRefreshCounter(commentsRefreshCounter + 1);
  };

  useEffect(() => {
    if (
      props.params.projectId ||
      filterValues?.status ||
      filterValues?.task ||
      refreshCounter ||
      updateOnPageChange
    )
      fetchFilteredShotversion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    appliedFilterKey,
    props.params.projectId,
    props.params.shotID,
    shotVersionFilteredStatus,
    currentPage,
    updateOnPageChange,
    refreshCounter,
  ]);

  function handleBackButton() {
    history.replace(
      history.location.pathname.split("/").slice(0, -2).join("/"),
    );
  }

  function handleNewshotVersionModalOpenState() {
    setNewShotVersionModalOpen(!isNewShotVersionModalOpen);
  }

  const handleShotVersionToggle = () => {
    setShotVersionToggle(!shotVersionToggle);
  };

  useEffect(() => {
    shotVersionList &&
      versionFromURL &&
      openVersionModalFromURL(versionFromURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [versionFromURL, shotVersionList]);

  //to open version modal by fetching id from the url
  const openVersionModalFromURL = (verId) => {
    handleShotDetailModalState(
      shotVersionList?.results?.filter((x) => x?.id === parseInt(verId))[0],
    );
  };

  function handleShotDetailModalState(shotVer) {
    searchParams.set("versionId", `${shotVer?.id}`);
    history.push(
      "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
    );

    setSelectedShotVersion(shotVer);
    setShotDetailModalOpen(true);
    document.title = shotVer.name;
  }

  async function fetchTrackableClass() {
    try {
      const trackableClasses = await fget({
        url: "trackables/trackable-classes/",
      });
      setTrackableClass(trackableClasses.data);
      if (trackableClasses.data) {
        const taskClassId = trackableClasses.data.find(
          (eachvalue) => eachvalue.model === "task",
        );
        if (taskClassId.id) {
          await fetchTaskStatusList(taskClassId.id);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchTaskStatusList(taskClassId) {
    try {
      const taskStatusList = await fget({
        url: `trackables/status-list/${taskClassId}/?project=${props.params.projectId}`,
      });
      if (taskStatusList.data) {
        setTaskStatusList(StatusRearrange(taskStatusList.data.results));
      }
    } catch (error) {}
  }

  async function fetchFilteredShotversion() {
    let url = `trackables/shot-version/v2/?shot=${props.params.shotID}&page=${currentPage}`;
    if (filterValues.status) {
      url += `&status=${filterValues.status}`;
    }
    if (filterValues.task) {
      url += `&task=${filterValues.task}`;
    }
    if (sortByDefault) {
      url += `&sortBy=${sortByDefault}`;
    }
    try {
      appliedFilterIds.forEach((filterId) => {
        url += `&filter=${filterId}`;
      });
      const res = await fget({ url });
      setShotVersionList(res.data);
      setIsLoaded(true);
      setIsNewPageLoading(false);
    } catch (error) {
      setIsNewPageLoading(false);
      console.error("Error loading filtered shot versions", error);
    }
    history.push("?" + btoa(unescape(encodeURIComponent(url.split("?")[1]))));
  }

  async function fetchShotVersion() {
    const assetversion = {
      url: "web/shotversion/list/",
      data: {
        project_id: props.params.projectId,
        shot_id: props.params.shotID,
      },
    };
    try {
      const res = await fpostBFF(assetversion);

      if (
        searchParams.get("status") === null ||
        searchParams.get("status") === ""
      ) {
        setStatusList(res.data?.status_list?.results);
        setIsLoaded(true);
      }
      setShotVersionStats((prevData) => ({
        ...prevData,
        visibleCount: res.data.shotversion_list.count,
      }));
      setParentShot(res.data.shot_details);
      // setAllUsers(res.data.project_users.results);
      setTaskList(res?.data?.tasks_list?.results);
      setAllUsersName(
        res.data.project_users.results.map((el) => {
          const data = {
            name: el.first_name + " " + el.last_name,
            id: el.id,
          };
          return data;
        }),
      );
      // setTask(res.data.tasks_list);
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: `Error on loading shot versions`,
        isError: true,
      });
      setIsLoaded(true);
    }
  }

  useEffect(() => {
    if (shotVersionList) {
      const fields = mapFieldsFromConfig(
        shotVersionList?.fields_config,
        shotVersionList?.custom_fields,
        shotVersionList?.default_fields,
      );
      setAllFieldsConfig(fields);
    }
    shotVersionList?.results &&
      searchParams.get("sortBy") &&
      handleSubmitSort(searchParams.get("sortBy"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shotVersionList]);

  //Function to sort AssetVersion
  function handleSubmitSort(sortBy) {
    searchParams.set("sortBy", `${sortBy}`);
    history.push(
      "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
    );

    switch (sortBy) {
      case "A-Z":
        shotVersionList?.results?.sort((a, b) => a.name.localeCompare(b.name));
        setSortByDefault("A-Z");
        break;
      case "Z-A":
        shotVersionList?.results?.sort((a, b) => b.name.localeCompare(a.name));
        setSortByDefault("Z-A");
        break;
      case "LatestModified":
        shotVersionList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateB - dateA;
        });
        setSortByDefault("LatestModified");
        break;
      case "LastModified":
        shotVersionList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateA - dateB;
        });
        setSortByDefault("LastModified");
        break;
      case "DateCreated":
        shotVersionList?.results?.sort(function (a, b) {
          var dateA = new Date(a.created_at),
            dateB = new Date(b.created_at);
          return dateA - dateB;
        });
        setSortByDefault("DateCreated");
        break;
      default:
        return shotVersionList?.results;
    }
  }

  const handleUpdatedFileForParent = (file) => {
    setUpdatedFileForParent(file);
    setUpdateParentShotModalOpen(true);
  };

  const updateParentShotThumbnail = async () => {
    let formdata = new FormData();
    formdata.append("code", parentShot ? parentShot.code : "");
    updatedFileForParent &&
      formdata.append("file_name", updatedFileForParent.name);
    formdata.append("status", parentShot?.status ? parentShot.status.id : "");
    formdata.append("project", props.params.projectId);
    formdata.append("description", parentShot ? parentShot.description : "");
    formdata.append("parent_sequence", props.params.sid);
    formdata.append("vp_linked_level_sequence", "");

    let updatedShot = {
      url: `trackables/shot/${props.params.shotID}/`,
      data: formdata,
    };

    try {
      const res = await fpatch(updatedShot);

      if (res.status === 200 || 201) {
        getSignedUrl(res.data.id);
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
      setUpdateParentShotModalOpen(false);
    }
  };
  const getSignedUrl = async (newId) => {
    try {
      const res = await fget({
        url: `trackables/shot/${newId}/upload`,
      });

      if (res.status === 200) {
        await uploadFile({
          url: res.data?.signed_url,
          data: updatedFileForParent,
        });

        await fget({ url: `trackables/shot/${newId}/thumbnail` });
        setSnackValue({
          isOpen: true,
          message: `SuccessFully updated thumbnail for parent shot ${parentShot.code}`,
          isError: false,
        });
        setUpdateParentShotModalOpen(false);
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
      setUpdateParentShotModalOpen(false);
    }
  };

  const handleDragFile = (e) => {
    setDragScreen(true);
    if (e.type === "drop") {
      //if we drop file , removing drag zone screen
      setDragScreen(false);
    }
    if (e.type === "dragleave") {
      //if we leave the drag file , removing drag zone screen
      if (dragFileEnterModal) {
        setDragScreen(true);
      } else {
        setDragScreen(false);
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragScreen = (el) => {
    setDragScreen(el);
  };

  const fetchFile = async () => {
    const fetchFileRes = await fget({
      url: `trackables/shotversion/${selectedShotVersion?.id}/file`,
    });
    return fetchFileRes.data.signed_url;
  };

  const fetchComments = async () => {
    let url = `trackables/trackable-comment/?version_id=${
      selectedShotVersion?.id
    }&version_type=${"shotversion"}&page=${commentsPageNo}&ordering=${commentFilter}`;

    const commentsRes = await fget({
      url: url,
    });

    return {
      comments: commentsRes.data.results
        .filter((el) => el.trackable.id === parseInt(props.params.shotID))
        .reverse(),
      isNextAvailable: commentsRes?.data?.next ? true : false,
    };
  };

  //function to change status by dropdown
  const handleStatusChange = async (e) => {
    let formdata = new FormData();

    formdata.append("status", e.target.value);
    let editedVersion = {
      url: `trackables/shot-version/${selectedShotVersion?.id}/`,
      data: formdata,
    };

    try {
      await fpatch(editedVersion);
      setSnackValue({
        isOpen: true,
        message: `SuccessFully changed status`,
        isError: false,
      });
      updateRefreshCounter();
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  // fetch tasks of the current trackable
  const fetchTasks = async () => {
    let url = `trackables/task/?project=${props.params.projectId}&linked=${props.params.shotID}`;

    try {
      const taskListRes = await fget({
        url: url,
      });
      setTaskList(taskListRes.data.results);
    } catch (error) {
      console.log(error);
    }
  };

  let shotVersionClass = trackableClass?.find(
    (el) => el.model === "shotversion",
  );

  const handleSubmit = async ({
    description,
    mentions,
    repliedTo,
    attachmentImage,
    timestamp,
  }) => {
    const formData = new FormData();
    formData.append("description", description);
    formData.append("trackable", props.params.shotID);
    formData.append("version_id", selectedShotVersion?.id);
    formData.append("version_type", shotVersionClass ? shotVersionClass.id : 0);
    formData.append("timestamp", timestamp || 0);

    mentions.forEach((mention) => {
      formData.append(`mentions`, mention);
    });

    if (repliedTo) formData.append("replied_to", repliedTo.id);

    if (attachmentImage) {
      const blob = await fetch(attachmentImage).then((res) => res.blob());
      const file = new File([blob], "img.jpg", { type: "image/jpg" });
      formData.append("attachment", file);
    }
    // mentionsRef.current.reset();
    let newComment = {
      url: "trackables/trackable-comment/",
      data: formData,
    };
    try {
      await fpost(newComment);
      return newComment;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const editComment = async (commentId, description, timestamp) => {
    const formData = new FormData();
    formData.append("description", description);
    formData.append("trackable", props.params.shotID);
    formData.append("version_id", selectedShotVersion?.id);
    formData.append("version_type", shotVersionClass.id || 0);
    formData.append("timestamp", timestamp || 0);
    let editedComment = {
      url: `trackables/trackable-comment/${commentId}/`,
      data: formData,
    };
    try {
      await fpatch(editedComment);
      return editedComment;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  let scrollTimer = null;
  const handleTableScroll = (e) => {
    if (scrollTimer !== null) clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
      searchParams.set("scroll", `${e.target.scrollTop}`);
      history.push(
        "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
      );
      let scrollStored = JSON.parse(localStorage.getItem("scroll"));
      scrollStored.shotVersion = e.target.scrollTop;
      localStorage.setItem("scroll", JSON.stringify(scrollStored));
    }, 700);
  };

  const getShotVersionStats = async () => {
    try {
      const shotVersionRes = await fget({
        url: `trackables/trackable-count/shotversion/${props.params.shotID}/`,
      });
      setShotVersionStats((prevData) => ({
        ...prevData,
        total: shotVersionRes.data.instances,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getShotVersionStats();
  }, [refreshCounter]);

  const fetchAllShotData = async () => {
    const PAGE_SIZE = 50;
    const firstRes = await fget({
      url: `trackables/shot-version/?page=1&shot=${props.params.shotID}&status=${filterValues.status}&task=${filterValues.task}`,
    });
    const totalCount = firstRes.data.count;
    const totalPages = Math.ceil(totalCount / PAGE_SIZE);

    if (totalPages <= 1) {
      return firstRes.data.results;
    }

    const remainingPromises = Array.from({ length: totalPages - 1 }, (_, i) =>
      fget({
        url: `trackables/shot-version/?page=${i + 2}&shot=${props.params.shotID}&status=${filterValues.status}&task=${filterValues.task}`,
      }),
    );
    const remainingResults = await Promise.all(remainingPromises);

    return [
      ...firstRes.data.results,
      ...remainingResults.flatMap((res) => res.data.results),
    ];
  };

  const createShotVersionInBulk = async (
    tableData,
    columnMappings,
    trackableType,
    defaultFields = [],
  ) => {
    const validApiFields = new Set(defaultFields.map((f) => f.name));
    const shotVersions = tableData.map((row) =>
      Object.fromEntries(
        Object.entries(columnMappings)
          .filter(
            ([, apiField]) =>
              apiField && apiField !== "none" && validApiFields.has(apiField),
          )
          .map(([csvHeader, apiField]) => [apiField, row[csvHeader]]),
      ),
    );
    shotVersions.forEach((shotVersion) => {
      shotVersion.project = props.params.projectId;
      shotVersion.shot = props.params.shotID;
    });
    try {
      const res = await fpost({
        url: `trackables/shot-version/v2/`,
        data: shotVersions,
      });
      if (res.status === 200 || res.status === 201) {
        setSnackValue({
          isOpen: true,
          message: "Shot versions imported successfully",
          isError: false,
        });
        updateRefreshCounter();
        return true;
      }
      setSnackValue({
        isOpen: true,
        message: "Error importing shot versions",
        isError: true,
      });
      return false;
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: error.response.data.detail || "Error importing shot versions",
        isError: true,
      });
      return false;
    }
  };

  return (
    <div
      className={classes.root}
      onDragEnter={(e) => handleDragFile(e)}
      onDrop={(e) => handleDragFile(e)}
      onDragLeave={(e) => handleDragFile(e)}
      onDragOver={(e) => handleDragFile(e)}
    >
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackValue.isOpen}
        autoHideDuration={2000}
        onClose={() => setSnackValue({ isOpen: false, message: "" })}
      >
        <Alert severity={snackValue.isError === false ? "success" : "warning"}>
          {snackValue.message}
        </Alert>
      </Snackbar>
      <ShotVersionsTools
        handleFilterModalState={handleFilterModalState}
        status={statusList}
        handleBackButton={handleBackButton}
        handleStatusChange={(value) => {
          setShotVersionFilteredStatus(value);
          if (value === "") {
            history.replace(history.location.pathname);
            window.location.reload();
          }
        }}
        filterValues={filterValues}
        openNewShotVersionModal={handleNewshotVersionModalOpenState}
        parentShot={parentShot}
        tabOption={0}
        handleShotVersionToggle={handleShotVersionToggle}
        onSubmit={handleSubmitSort}
        defaultvalue={sortByDefault}
        filterButtonActive={filterButtonActive}
        projectId={props.params.projectId}
        shotVersionStats={shotVersionStats}
        handleOpenTimelineModal={() => setIsTimeLineModalOpen(true)}
        handleOpenExportModal={() => setIsExportModalOpen(true)}
        handleOpenBulkImportModal={() => setOpenBulkImportModal(true)}
        isToggleView={isToggleView}
        handleToggleView={() => setIsToggleView(!isToggleView)}
      />
      {!isLoaded && <Loader />}
      {isLoaded && shotVersionList && shotVersionList.count === 0 && <NoData />}
      {isLoaded && shotVersionList && shotVersionList.count > 0 && (
        <>
          <div
            style={{
              height:
                shotVersionList.count > 50
                  ? `calc(100vh - 225px)`
                  : `calc(100vh - 180px)`,
              width: "100%",
              overflow: "hidden",
            }}
          >
            {isToggleView ? (
              <ShotVersionCustomTable
                shotVersionList={shotVersionList}
                projectId={props.params.projectId}
                statusList={statusList}
                updateRefreshCounter={updateRefreshCounter}
                setSnackValue={setSnackValue}
                allFieldsConfig={allFieldsConfig}
                handleTableScroll={handleTableScroll}
                handleShotDetailModalState={handleShotDetailModalState}
                sequenceId={props.params.sid}
                shotID={props.params.shotID}
                dragScreen={dragScreen}
                handleDragScreen={handleDragScreen}
                setDragFileEnterModal={setDragFileEnterModal}
                taskList={taskList}
                fetchTasks={fetchTasks}
                customFields={shotVersionList?.custom_fields}
              />
            ) : (
              <ShotVersionDefaultTable
                shotVersionList={shotVersionList}
                taskList={taskList}
                fetchTasks={fetchTasks}
                updateRefreshCounter={updateRefreshCounter}
                dragScreen={dragScreen}
                handleDragScreen={handleDragScreen}
                setDragFileEnterModal={setDragFileEnterModal}
                handleShotDetailModalState={handleShotDetailModalState}
                shotVersionToggle={shotVersionToggle}
                fetchShotVersion={fetchShotVersion}
                statusList={statusList}
                sid={props.params.sid}
                shotID={props.params.shotID}
                projectId={props.params.projectId}
                tableRef={tableRef}
                handleTableScroll={handleTableScroll}
                scrollValue={scrollValue}
              />
            )}
          </div>
          {shotVersionList.count > 50 && (
            <footer style={{ bottom: "0", height: "100%" }}>
              <div>
                <CustomPagination
                  handlePageChange={handlePageChange}
                  currentPage={currentPage}
                  totalItem={shotVersionList?.count}
                  totalPage={Math.ceil(shotVersionList?.count / 50)}
                  setIsNewPageLoading={setIsNewPageLoading}
                />
              </div>
            </footer>
          )}
        </>
      )}
      <Modal className={classes.shotVersionPageModals} open={isNewPageLoading}>
        <NewDataLoadingLoader trackable="Shot Versions" />
      </Modal>

      <Modal
        open={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        className={classes.shotVersionPageModals}
      >
        <VersionFilterModal
          updateList={() => fetchFilteredShotversion()}
          closeModal={handleFilterModalState}
          taskList={taskList}
          status={statusList}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          setFilterButtonActive={setFilterButtonActive}
        />
      </Modal>

      <Modal
        className={classes.shotVersionPageModals}
        open={isNewShotVersionModalOpen}
        onClose={() => setNewShotVersionModalOpen(false)}
      >
        <ShotVersionNewVersionModal
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          handleUpdatedFileForParent={handleUpdatedFileForParent}
          projectId={props.params.projectId}
          shotID={props.params.shotID}
          status={statusList}
          handleShotVersionModal={handleNewshotVersionModalOpenState}
          updateRefreshCounter={updateRefreshCounter}
          taskList={taskList}
          fetchTasks={fetchTasks}
          customFields={shotVersionList?.custom_fields}
        />
      </Modal>

      <Modal
        className={classes.shotVersionPageModals}
        open={isUpdateParentShotModalOpen}
        onClose={() => setUpdateParentShotModalOpen(false)}
      >
        <UpdateParentAssetOrShootThumbnailModal
          versionType="Shot"
          parent={parentShot}
          handleSubmit={() => {
            updateParentShotThumbnail();
          }}
          closeUpdateParentModal={() => setUpdateParentShotModalOpen(false)}
        />
      </Modal>

      <Modal
        // className={classes.shotVersionPageModals}
        open={isShotDetailModalOpen}
        onClose={() => {
          setShotDetailModalOpen(false);
          searchParams.set("versionId", "");
          setVersionFromURL("");
          history.push(
            "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
          );
          document.title = "MovieColab";
        }}
      >
        <VersionViewerOverview
          commentsPageNo={commentsPageNo}
          setCommentsPageNo={setCommentsPageNo}
          versionList={shotVersionList}
          selectedVersion={selectedShotVersion}
          setSelectedVersion={setSelectedShotVersion}
          projectId={props.params.projectId}
          fetchFile={fetchFile}
          fetchComments={fetchComments}
          parentTrackable={parentShot}
          closeModal={() => {
            setShotDetailModalOpen(false);
            setVersionFromURL("");
            searchParams.set("versionId", "");
            history.push(
              "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
            );
            document.title = "MovieColab";
          }}
          handleStatusChange={handleStatusChange}
          status={statusList}
          updateRefreshCounter={updateRefreshCounter}
          setTaskNameFromComment={setTaskNameFromComment}
          canvasModal={canvasModal}
          setCanvasModal={setCanvasModal}
          setImageRef={setImageRef}
          setScreenshot={setScreenshot}
          screenshot={screenshot}
          allUsersName={allUsersName}
          handleSubmit={handleSubmit}
          version_type={shotVersionClass ? shotVersionClass.id : 0}
          assetId={props.params.shotID}
          setPlayerProgress={setPlayerProgress}
          commentsRefreshCounter={commentsRefreshCounter}
          taskStatusList={taskStatusList}
          commentId={commentId}
          commentFilter={commentFilter}
          changeCommentFilter={setCommentFilter}
          editComment={editComment}
        />
      </Modal>

      <Modal className={classes.shotVersionPageModals} open={canvasModal}>
        <CanvasFrame
          imageRef={imageRef}
          image={screenshot}
          assetID={props.params.shotID}
          toggle={() => setCanvasModal(!canvasModal)}
          fetchComments={fetchComments}
          version_id={selectedShotVersion?.id}
          version_type={shotVersionClass ? shotVersionClass.id : 0}
          users={allUsersName}
          progress={playerProgress}
          closeModal={() => setCanvasModal(false)}
          updateCommentsRefreshCounter={updateCommentsRefreshCounter}
        />
      </Modal>
      {isTimeLineModalOpen && (
        <Slide direction="left" in={isTimeLineModalOpen}>
          <Box
            style={{
              display: isTimeLineModalOpen ? "block" : "none",
              top: "157px",
              height: `calc(100vh - 157px)`,
            }}
            className={classes.floatingDiv}
          >
            <AssetAndShotVersionTimeline
              type="shot"
              id={props.params.shotID}
              parent={parentShot}
              handleClose={() => setIsTimeLineModalOpen(false)}
            />
          </Box>
        </Slide>
      )}
      <Modal
        className={classes.shotVersionPageModals}
        open={openBulkImportModal}
        onClose={() => setOpenBulkImportModal(false)}
      >
        <CSVImportModal
          createInBulk={createShotVersionInBulk}
          trackableType="shotversion"
          closeModal={() => setOpenBulkImportModal(false)}
          projectId={props.params.projectId}
          requiredFields={["name"]}
        />
      </Modal>
      <Modal
        className={classes.shotVersionPageModals}
        open={isExportModalOpen}
        onClose={() => {
          setIsExportModalOpen(false);
        }}
      >
        <ExportModal
          headersList={[
            "Shot Version Name",
            "Added On",
            "Status",
            "Created By",
            "Related Task",
            "Comments",
          ]}
          valuesList={[
            { name: "name", type: "string" },
            { name: "updated_at", type: "date" },
            { name: "status", type: "object", key: "name" },
            {
              name: "created_by",
              type: "object",
              key: "first_name",
              key2: "last_name",
            },
            { name: "task", type: "object", key: "name" },
            { name: "related_comments_number", type: "number" },
          ]}
          fetchAllData={fetchAllShotData}
          handleClose={() => setIsExportModalOpen(false)}
        />
      </Modal>
    </div>
  );
}

export default ShotVersionsOverview;
